import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { GET_UNDER_ENFORCEMENT } from "../../../queries/archiveQrys/secureQrys/enfDashboardQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const colors = ["#a40606", "#108c4f", "#d2b307"];

const UnderEnforcement = () => {
  const { loading, error, data } = useQuery(GET_UNDER_ENFORCEMENT);
  if (loading)
    return (
      <>
        <h3>Under Enforcement</h3>
        <SkeletonLoader width='100%' />
      </>
    );
  if (error) return <ErrorHandler error={error} />;
  if (!data)
    return (
      <>
        <h3>Under Enforcement</h3>
        <span>No Data Returned</span>
      </>
    );

  const RADIAN = Math.PI / 180;
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.05;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill='black' textAnchor={x > cx ? "start" : "end"} dominantBaseline='central'>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Under Enforcement</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='underEnfLegend'>
          <Legend
            wrapperStyle={{ position: "relative" }}
            payload={data.getSystemsUnderEnforcement.map((item, index) => ({
              id: item.name,
              value: `${item.name}: ${item.value}`,
              color: colors[index % colors.length]
            }))}
            iconSize={0}
            verticalAlign='top'
            align={"left"}
            style={{ position: "relative" }}
          />
        </Col>
      </Row>
      <Row>
        <Col cypressid='underEnfPieChart'>
          <PieChart width={375} height={325}>
            <Pie
              data={data.getSystemsUnderEnforcement}
              cx='55%'
              cy='60%'
              labelLine={false}
              label={renderCustomLabel}
              dataKey='value'
            >
              {data.getSystemsUnderEnforcement.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
          </PieChart>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UnderEnforcement;
